export const FALLBACK_SEPARATOR = ',';
// The regex below are taken from the following dependency to match - `@internationalized/date/src/string.ts`
export const ISO_DATE_REGEX = /^(\d{4})-(\d{2})-(\d{2})$/;
export const ISO_TIME_REGEX = /^(\d{2})(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
export const ISO_DATE_TIME_REGEX = /^(\d{4})-(\d{2})-(\d{2})T(\d{2})?:(\d{2})(?::(\d{2}))?(\.\d+)?$/;
